import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators, AbstractControl, FormControl } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { DocumentosAuditoriaService } from 'src/app/services/documentos-auditoria.service';

import * as JSZip from 'jszip';
import swal from 'sweetalert';

@Component({
  selector: 'app-documentos-auditoria',
  templateUrl: './documentos-auditoria.component.html',
  styleUrls: ['./documentos-auditoria.component.css']
})
export class DocumentosAuditoriaComponent implements OnInit {


  // Formulario
  formAuditoria: FormGroup;

  // Años
  fecha = new Date();
  anio = this.fecha.getFullYear();
  anioMenosUno = this.anio - 1;
  anioMenosDos = this.anio - 2;

  idContratista: any;
  token: String;

  error: boolean = false;
  errorMsg: any;

  contratista;
  rfc;
  emailContratista;
  tokenSesion: any;
  idSolicitud: any;
  loading: boolean = false;

  constructor(private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    public _documentosAuditoriaService: DocumentosAuditoriaService,
    private router: Router) {
    this.idContratista = this.route.snapshot.queryParamMap.get("c");
    this.token = this.route.snapshot.queryParamMap.get("t");
  }

  ngOnInit() {
    this.formAuditoria = this.formBuilder.group({
      edoFinAuditados: ['', [Validators.required, requiredFileType('pdf')]],
      edoFinInternos: ['', [Validators.required, requiredFileType('pdf')]],
      relActActivos: ['', [Validators.required, requiredFileType('pdf')]],
      declaracionAnual: ['', [Validators.required, requiredFileType('pdf')]],
    });
    this.cargaInicial();
  }

  async cargaInicial() {

    await this.getContratista(this.idContratista, this.token);

  }


  onFileSelect(event) {
    if (event.target.files.length > 0) {

      const nombre = event.target.name;

      // console.log(nombre)

      const file = event.target.files[0];

      this.formAuditoria.get(nombre).setValue(file);

      // console.log(this.formAuditoria.value);

    }
  }

  get f() { return this.formAuditoria.controls; }


  // obtener datos del contratista
  getContratista(idContratista, token) {
    return new Promise((resolve, reject) => {

      this._documentosAuditoriaService.datosContratista(idContratista, token)
        .subscribe((resp: any) => {

          this.contratista = resp.datos.nombre;
          this.rfc = resp.datos.rfc;
          this.emailContratista = resp.datos.emailContratista;
          this.tokenSesion = resp.datos.tokenSesion,
          this.idSolicitud = resp.datos.idSolicitud;
          return resolve();

        }, error => {

          alert('Ocurrió un error al obtener los datos del contratista. '
            + 'Por favor recargue la ventana');
          this.error = true;
          this.errorMsg = error.error;
          console.log(error);

        });
    });
  }

  onSubmit() {

    this.validateAllFormFields(this.formAuditoria);

    if (this.formAuditoria.invalid) return false;

    console.log('correcto')
    this.loading = true;

    const zipAud = new JSZip();

    zipAud.file('edoFinAuditados.pdf', this.formAuditoria.get('edoFinAuditados').value);

    zipAud.file('edoFinInternos.pdf', this.formAuditoria.get('edoFinInternos').value);
    zipAud.file('relActActivos.pdf', this.formAuditoria.get('relActActivos').value);
    zipAud.file('declaracionAnual.pdf', this.formAuditoria.get('declaracionAnual').value);

    zipAud.generateAsync({ type: 'blob' })
      .then((contentAud) => {
        // console.log(content); return;
        const form = new FormData();
        form.append('nombre', this.contratista);
        form.append('email', this.emailContratista);
        form.append('zipAud', contentAud);


        this._documentosAuditoriaService.enviarDatos(this.idContratista, this.rfc, form, this.idSolicitud, this.tokenSesion)
        .subscribe((resp: any) => {
          // console.log(resp);
          swal('Ok!', 'Documentos enviados correctamente', 'success');
          this.loading = false;
          this.router.navigate(['/inicio']);
        }, error => {
          console.log(error);
          swal('Error!', 
          'Ocurrió un problema al intentar cargar los documentos', 
          'error');
          console.log(error);
          this.loading = false;
        })

      });
  }





  //******** Función que  valida si cada campo es válido al hacer submit */
  validateAllFormFields(formGroup: FormGroup) {         //{1}
    Object.keys(formGroup.controls).forEach(field => {  //{2}
      const control = formGroup.get(field);             //{3}
      if (control instanceof FormControl && !control.disabled) {             //{4}
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof FormGroup) {        //{5}
        this.validateAllFormFields(control);            //{6}
      }
    });
  }

}

export function requiredFileType(type: string) {
  return function (control: FormControl) {
    const file = control.value;
    if (file) {
      const extension = file.name.split('.')[1].toLowerCase();
      // console.log(extension);
      if (type.toLowerCase() !== extension.toLowerCase()) {
        return {
          requiredFileType: true
        };
      }

      return null;
    }

    return null;
  };
}
